import { useTranslations } from '@vocab/react';
import { IconSecurity, List, Text } from 'braid-design-system';
import React from 'react';

import translations from '../../../locales.vocab';

const StripeSecureCardTip = () => {
  const { t } = useTranslations(translations);

  return (
    <List space="medium" type="icon" icon={<IconSecurity tone="neutral" />}>
      <Text tone="secondary" size="small">
        {t('stripe.tip')}
      </Text>
    </List>
  );
};

export default StripeSecureCardTip;
